const SET_RESEARCHERS = (state, users) => {
	state.researchers = users
}

const SET_ACTIVITIES = (state, activities) => {
	state.activities = activities
}

export default {
	SET_RESEARCHERS,
	SET_ACTIVITIES,
}
